import React from 'react';

import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { XSS_FILTER_OPTIONS } from 'apps/auth/constants/Constants';

const ClientSideDisclaimer = ({ linkTo, title, text, onButtonClick, buttonCaption }) => {
    return (
        <ModalComponent linkTo={linkTo} hasBottomPanel>
            <HeaderPanel title={title} />
            <article className="maincopy break_words first" id="disclaimer" dangerouslySetInnerHTML={{ __html: filterXSS(text, XSS_FILTER_OPTIONS) }} />
            <FixedBottomPanel isRightAligned>
                <Button type="button" raised={true} onClick={onButtonClick} caption={buttonCaption} dataTestId="disclaimer-continue-button" />
            </FixedBottomPanel>
        </ModalComponent>
    );
};

export default ClientSideDisclaimer;
